import RewardBundlingAwarenessMessage from 'components/RwdBasket/RwdBasketLayout/TopContentMessages/RewardBundlingAwarenessMessage/RewardBundlingAwarenessMessage';

export default RewardBundlingAwarenessMessage;
